import { useTranslation } from "next-i18next";
import { Box, Flex, useColorModeValue } from "@chakra-ui/react";
import { Container, CopyLinkIcon, EthHighIcon, EditIcon, useBoxShadowPreset } from "@looksrare/uikit";
import { Text, Button } from "uikit";

const HowItWorks = () => {
  const { t } = useTranslation();
  const boxShadow = useBoxShadowPreset("card");
  const borderGradient = `${useColorModeValue(
    "linear(135deg, #3C4147, #AFAFAF)",
    "linear(135deg, #21252B, #121619)"
  )}}`;

  const howItWorksBoxOuterSharedProps = {
    bgGradient: borderGradient,
    borderRadius: "container",
    padding: "1px",
    boxShadow: boxShadow,
    flex: "1",
  };

  const howItWorksBoxSharedProps = {
    bgGradient: "linear(ui-gradient-02-b, ui-gradient-02-a)",
    borderRadius: "container",
    flex: "1",
  };

  return (
    <Container maxWidth="1200px" pt={8} mb={8}>
      <Text textStyle="display-03" bold mb={12}>
        {t("Here's How It Works")}
      </Text>
      <Flex gap={6} flexDirection={{ base: "column", md: "row" }} mb={8}>
        <Flex {...howItWorksBoxOuterSharedProps}>
          <Box {...howItWorksBoxSharedProps} p={8}>
            <EditIcon boxSize={12} mb={6} />
            <Text textStyle="display-body" bold mb={6}>
              {t("Complete the form")}
            </Text>
            <Text>{t("Tell us a bit about yourself, your audience and your activities.")}</Text>
            <Text>{t("The team will swiftly review your application and whitelist you if it's successful.")}</Text>
          </Box>
        </Flex>
        <Flex {...howItWorksBoxOuterSharedProps}>
          <Box {...howItWorksBoxSharedProps} p={8}>
            <CopyLinkIcon boxSize={12} mb={6} />
            <Text textStyle="display-body" bold mb={6}>
              {t("Get your ref")}
            </Text>
            <Text>
              {t(
                "We'll provide you with a ref string you can add to any LooksRare URL — perfect for showing off collections across socials, in emails, on your website, etc."
              )}
            </Text>
          </Box>
        </Flex>
        <Flex {...howItWorksBoxOuterSharedProps}>
          <Box {...howItWorksBoxSharedProps} p={8}>
            <EthHighIcon boxSize={12} mb={6} />
            <Text textStyle="display-body" bold mb={6}>
              {t("Start earning ETH")}
            </Text>
            <Text>
              {t(
                "Once a referral becomes active after clicking your link, you'll earn ETH rewards on their 'maker' activities (creating listings, making offers, etc.). You can track your earnings in real time on your dashboard."
              )}
            </Text>
          </Box>
        </Flex>
      </Flex>
      <Flex>
        <Button
          as="a"
          href="https://docs.google.com/forms/d/1Fwz3zvxTZf4a3ZGbLrSX7xJdZIAMnPAHm5MSawHhUbk"
          marginLeft="auto"
          target="_blank"
          rel="noopener noreferrer"
        >
          {t("Apply Now")}
        </Button>
      </Flex>
    </Container>
  );
};

export default HowItWorks;
